export default __webpack_public_path__ + "static/media/SearchLogo.60391463.svg";